import React, { useState, useEffect } from 'react';
import { IconButton, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

function DeleteWithCountdownButton({ onConfirm, disabled }) {
  const [countdown, setCountdown] = useState(0);
  const [countdownStart, setCountdownStart] = useState(null);

  const handleClick = () => {
    if (countdown > 0) {
      onConfirm();
      setCountdown(0);
    } else {
      setCountdownStart(Date.now());
      setCountdown(3);
    }
  };

  useEffect(() => {
    if (countdown > 0) {
      const interval = setInterval(() => {
        const elapsed = Math.floor((Date.now() - countdownStart) / 1000);
        const remaining = Math.max(0, 3 - elapsed);
        setCountdown(remaining);
        if (remaining === 0) clearInterval(interval);
      }, 100);
      return () => clearInterval(interval);
    }
  }, [countdown, countdownStart]);

  return (
    <IconButton size='small' color='error' onClick={handleClick} disabled={disabled}>
      {countdown > 0 ? (
        <>
          <Typography variant='caption'>{countdown}</Typography>
          <DeleteIcon />
        </>
      ) : (
        <DeleteIcon />
      )}
    </IconButton>
  );
}

export default DeleteWithCountdownButton;
